import { AccountPromotion, SubscriptionPromotion } from "common/elements";
import { UserPage } from "features/user";
import { RedirectSignUp } from "features/parent";
import { ProjectPreview } from "features/preview";
import { Rating, Feedback } from "features/review";
import { Contact, UniversalPanel } from "features/universal";
import { SmartAppBanner, PwaInstallBanner } from "features/install";
import { AppLoading } from "./AppLoading";

export const DialogPage = () => {
  return (
    <>
      <Rating />
      <Contact />
      <Feedback />
      <UserPage />
      <AppLoading />
      <UniversalPanel />
      <ProjectPreview />
      <SmartAppBanner />
      <RedirectSignUp />
      <PwaInstallBanner />
      <AccountPromotion />
      <SubscriptionPromotion />
    </>
  );
};
